import React from "react";
import Incomes from "./income";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const IncomesController = async ({ res, req, load, locals }) => {
  const { query = {} } = req;
  const { selector = 3, loadData } = query;

  if (loadData) {
    if (locals.activeUser.organizationId) {
      await load(`feIncomes`, {
        organizationUser: locals.activeUserToRequest._id,
        selector,
      });
    } else {
      await load("feIncomes", { selector });
    }
  }

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = <Incomes selector={selector} loadData={loadData} />;
};

export default IncomesController;
